import styled from "styled-components"
import { TableCell, TableRow } from "client/components"

export const TableRowStyled = styled(TableRow)<{
    newRow?: boolean
    deleteRow?: boolean
}>`
    overflow: visible;
    background: ${(props) => {
        if (props.newRow) return props.theme.qidDatapointNewBackground
        if (props.deleteRow) return props.theme.qidDatapointDeleteBackground
        return props.theme.tableRowBackground
    }};
    
    &:hover {
        background: ${(props) => {
        if (props.newRow) return props.theme.qidDatapointNewHoverBackground
        if (props.deleteRow) return props.theme.qidDatapointDeleteHoverBackground
        return props.theme.tableRowHoverBackground
    }};
    }
`
export const TableCellAddWrapper = styled(TableCell)`
    background: ${(props) => props.theme.qidDatapointAddButtonBackground};
`
export const AddSpan = styled.span`
    font-size: ${(props) => props.theme.fontSizes.md}px !important;
    font-family: ${(props) => props.theme.openSans};
    font-weight: 600;
    text-transform: uppercase;
    user-select: none;
`
export const NewStatus = styled.span`
    color: ${(props) => props.theme.qidDatapointNewStatus};
`
export const DeleteStatus = styled.span`
    color: ${(props) => props.theme.qidDatapointDeleteStatus};
`
